import { HisJobOption } from './his-job-option';
import { HisSearchRequest } from '../../genericsearch/model/his-search-request';
import { HisOption } from '../../genericsearch/model/his-option';

export class HisJobRequest {
    jobConfiguration: string; // the guid of the job configuration item which was used to create this request
    jobKey: string;  // key that allows HISinOne to identify the job to start
    executionType: string; // Typ der Job-Ausführung (Falls serverseitig mehrere Mechanismen zur Ausführung existieren)
    jobStarterKey: string; // jobStarter, um Parameter gegen die Settings vergleichen zu können

    searchRequest?: HisSearchRequest; // Generische Suche, welche die Job-Ausführung inhaltlich einschränken soll.

    selectedRowData?: HisOption[]; // Ausgewählte Zeilen des generischen Suchergebnis - alle, wenn leer

    jobParams?: any; // Job-Parameter aus den Settings des Auftrags

    constructor( jobMetadata: HisJobOption ) {
        this.jobConfiguration = jobMetadata.jobConfiguration;
        this.jobKey = jobMetadata.key;
        this.executionType = 'JobManagement'; // use standard JobManagement
    }
}
